/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface IntermediateEvent
 */
export interface IntermediateEvent {
  /**
   *
   * @type {string}
   * @memberof IntermediateEvent
   */
  readonly uuid?: string;
  /**
   *
   * @type {IntermediateEventEventTypeEnum}
   * @memberof IntermediateEvent
   */
  eventType: IntermediateEventEventTypeEnum | null;
  /**
   *
   * @type {Date}
   * @memberof IntermediateEvent
   */
  eventDate: Date;
  /**
   *
   * @type {string}
   * @memberof IntermediateEvent
   */
  measuringpointCode: string;
  /**
   *
   * @type {string}
   * @memberof IntermediateEvent
   */
  gmwBroId: string;
  /**
   *
   * @type {number}
   * @memberof IntermediateEvent
   */
  tubeNumber: number;
  /**
   *
   * @type {Date}
   * @memberof IntermediateEvent
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof IntermediateEvent
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof IntermediateEvent
   */
  gmn: string;
  /**
   *
   * @type {string}
   * @memberof IntermediateEvent
   */
  dataOwner: string;
}

/**
 * @export
 */
export const IntermediateEventEventTypeEnum = {
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnTubeReference: "GMN_TubeReference",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnStartRegistration: "GMN_StartRegistration",
} as const;
export type IntermediateEventEventTypeEnum =
  (typeof IntermediateEventEventTypeEnum)[keyof typeof IntermediateEventEventTypeEnum];

/**
 * Check if a given object implements the IntermediateEvent interface.
 */
export function instanceOfIntermediateEvent(value: object): value is IntermediateEvent {
  if (
    (!("eventType" in (value as Record<string, any>)) &&
      !("event_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventType"] === undefined &&
      (value as Record<string, any>)["event_type"] === undefined)
  )
    return false;
  if (
    (!("eventDate" in (value as Record<string, any>)) &&
      !("event_date" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["eventDate"] === undefined &&
      (value as Record<string, any>)["event_date"] === undefined)
  )
    return false;
  if (
    (!("measuringpointCode" in (value as Record<string, any>)) &&
      !("measuringpoint_code" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["measuringpointCode"] === undefined &&
      (value as Record<string, any>)["measuringpoint_code"] === undefined)
  )
    return false;
  if (
    (!("gmwBroId" in (value as Record<string, any>)) &&
      !("gmw_bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["gmwBroId"] === undefined &&
      (value as Record<string, any>)["gmw_bro_id"] === undefined)
  )
    return false;
  if (
    (!("tubeNumber" in (value as Record<string, any>)) &&
      !("tube_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["tubeNumber"] === undefined &&
      (value as Record<string, any>)["tube_number"] === undefined)
  )
    return false;
  if (!("gmn" in value) || value["gmn"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function IntermediateEventFromJSON(json: any): IntermediateEvent {
  return IntermediateEventFromJSONTyped(json, false);
}

export function IntermediateEventFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IntermediateEvent {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    eventType: json["event_type"],
    eventDate: new Date(json["event_date"]),
    measuringpointCode: json["measuringpoint_code"],
    gmwBroId: json["gmw_bro_id"],
    tubeNumber: json["tube_number"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    gmn: json["gmn"],
    dataOwner: json["data_owner"],
  };
}

export function IntermediateEventToJSON(json: any): IntermediateEvent {
  return IntermediateEventToJSONTyped(json, false);
}

export function IntermediateEventToJSONTyped(
  value?: Omit<IntermediateEvent, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    event_type: value["eventType"],
    event_date: value["eventDate"].toISOString().substring(0, 10),
    measuringpoint_code: value["measuringpointCode"],
    gmw_bro_id: value["gmwBroId"],
    tube_number: value["tubeNumber"],
    gmn: value["gmn"],
    data_owner: value["dataOwner"],
  };
}
